<div
  id="main-navigation"
  class="nav"
  [ngClass]="{'horizontal':layout === 'horizontal', 'vertical':layout === 'vertical'}"
>
  <!-- Vertical Navigation Layout -->
  <ng-container *ngIf="layout === 'vertical'">
    <ng-container *ngFor="let item of navigation">
      <app-nav-vertical-group
        *ngIf="item.type==='group'"
        [item]="item"
      ></app-nav-vertical-group>
      <app-nav-vertical-collapse
        *ngIf="item.type==='collapse'"
        [item]="item"
      ></app-nav-vertical-collapse>
      <app-nav-vertical-item
        *ngIf="item.type==='item'"
        [item]="item"
      ></app-nav-vertical-item>
    </ng-container>
  </ng-container>
  <!-- / Vertical Navigation Layout -->
  <!-- Horizontal Navigation Layout -->
  <ng-container *ngIf="layout === 'horizontal'">
    <ng-container *ngFor="let item of navigation">
      <app-nav-horizontal-collapse
        *ngIf="item.type==='group'"
        [item]="item"
      ></app-nav-horizontal-collapse>
      <app-nav-horizontal-collapse
        *ngIf="item.type==='collapse'"
        [item]="item"
      ></app-nav-horizontal-collapse>
      <app-nav-horizontal-item
        *ngIf="item.type==='item'"
        [item]="item"
      ></app-nav-horizontal-item>
    </ng-container>
  </ng-container>
  <!-- / Horizontal Navigation Layout -->
</div>
